import React, { useEffect, useState } from "react";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

function Phone({ value, setValue, international }) {
  return (
    <React.Fragment>
      <p style={{ marginBottom: 5 }}>
        <strong>Teléfono</strong>
      </p>
      {international ? (
        <PhoneInput
          country={"py"}
          value={value}
          onChange={setValue}
          placeholder="Numero de teléfono"
          inputStyle={{ height: 33, borderRadius: 0, width: 100 }}
        />
      ) : (
        <PhoneInput
          country={"py"}
          value={value}
          onChange={(phone) => {
            if (phone.length < 13) {
           
              setValue("+" + phone);
            }
          }}
          placeholder="+5959xxxxxxxx"
          disableDropdown={true}
          inputProps={{ value: value }}
          inputStyle={{ height: 30, borderRadius: 0, width: "100%" }}
          containerStyle={{ marginBottom: 15 }}
        />
      )}
    </React.Fragment>
  );
}

export default Phone;
